// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DDqL","content":"styles_content__34QRk","row":"styles_row__1h4EA","footer":"styles_footer__3ne3i","phraseLength":"styles_phraseLength__3rlFk"};